import { EWalletType } from "Stores/WalletStore";

export function satisfiesEnum<T>(value: any, enumeration: T): value is T {
	if (typeof enumeration !== "object" || enumeration === null) throw new Error("Enumeration must be an object");
	return Object.values(EWalletType).includes(value);
}
